export const getCSRFCookie = () => {
  return document.cookie.match(new RegExp('(XSRF-TOKEN)=([^;]*)'))
}

export const fetchCSRFToken = async (baseUrl: string) => {
  await fetch(`${baseUrl}/sanctum/csrf-cookie`, {
    credentials: 'include',
  })

  return getCSRFCookie()
}
